module.exports = __webpack_public_path__ + "static/media/ic_remote_control.dadf2bed.svg";